import { render, staticRenderFns } from "./TtsReaderElementSettings.vue?vue&type=template&id=2c60be6e&scoped=true&"
import script from "./TtsReaderElementSettings.vue?vue&type=script&lang=ts&"
export * from "./TtsReaderElementSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c60be6e",
  null
  
)

export default component.exports